import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';
import queries from '../../../utils/queries'
var moment = require('moment');

class LabDashboard2 extends React.Component {
  state={permiteUpdate: true, confirmaAct: false, open: false,
    argsQuery: `{$match: {fechaCreate: { $gte: new Date('2024-06-01')}, 'estadoInflab': {$in: ['FINALIZADO', 'GENERADO']}}},
    {$project: {_id: 1, mecInflab: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1, 
    descrLubricante: 1, estadoEnvio: 1, fechaEnvioCliente: 1, fechaEnvioLab: 1, fechaRecibeLab: 1, fechaCreate: 1, fechaMuestra: 1, estadoInflab: 1, 
    estado: 1, cambioFiltroAc: 1, cambioFiltroAire: 1}}`,
    lineaPru: [
      {pru:'visco40', linea:25, tipo:'PROPIEDADES FISICO', nombre:'Viscosidad, cSt a 40ºC'}, 
      {pru:'visco100', linea:26, tipo:'PROPIEDADES FISICO', nombre:'Viscosidad, cSt a 100ºC'}, 
      {pru:'indice', linea:27, tipo:'PROPIEDADES FISICO', nombre:'Índice de Viscosidad IV'}, 
      {pru:'tan', linea:28, tipo:'PROPIEDADES QUIMICAS', nombre:'TAN'}, 
      {pru:'tbn', linea:29, tipo:'PROPIEDADES QUIMICAS', nombre:'TBN'}, 
      {pru:'agua', linea:30, tipo:'CONTAMINACION', nombre:''}, 
      {pru:'codigoPar', linea:31, tipo:'CONTAMINACION', nombre:''}, 
      {pru:'micras4', linea:32, tipo:'CONTAMINACION', nombre:''}, 
      {pru:'micras6', linea:33, tipo:'CONTAMINACION', nombre:''}, 
      {pru:'micras14', linea:34, tipo:'CONTAMINACION', nombre:''}, 
      {pru:'micras21', linea:35, tipo:'CONTAMINACION', nombre:''}, 
      {pru:'micras25', linea:36, tipo:'CONTAMINACION', nombre:''}, 
      {pru:'micras38', linea:37, tipo:'CONTAMINACION', nombre:''}, 
      {pru:'micras70', linea:38, tipo:'CONTAMINACION', nombre:''}, 
      {pru:'hollin', linea:39, tipo:'INFRA-ROJO (abs /  mm)', nombre:''}, 
      {pru:'nitracion', linea:40, tipo:'INFRA-ROJO (abs /  mm)', nombre:''}, 
      {pru:'sulfatacion', linea:41, tipo:'INFRA-ROJO (abs /  mm)', nombre:''}, 
      {pru:'dilucion', linea:42, tipo:'INFRA-ROJO (abs /  mm)', nombre:''}, 
      {pru:'glicol', linea:43, tipo:'INFRA-ROJO (abs /  mm)', nombre:''}, 
      {pru:'oxidacion', linea:44, tipo:'INFRA-ROJO (abs /  mm)', nombre:''}, 
      {pru:'hierro', linea:45, tipo:'DESGASTE DE METALES(ppm)', nombre:''}, 
      {pru:'cobre', linea:46, tipo:'DESGASTE DE METALES(ppm)', nombre:''}, 
      {pru:'aluminio', linea:47, tipo:'DESGASTE DE METALES(ppm)', nombre:''}, 
      {pru:'cromo', linea:48, tipo:'DESGASTE DE METALES(ppm)', nombre:''}, 
      {pru:'plomo', linea:49, tipo:'DESGASTE DE METALES(ppm)', nombre:''}, 
      {pru:'estano', linea:50, tipo:'DESGASTE DE METALES(ppm)', nombre:''}, 
      {pru:'niquel', linea:51, tipo:'DESGASTE DE METALES(ppm)', nombre:''},
      {pru:'titanio', linea:52, tipo:'DESGASTE DE METALES(ppm)', nombre:''}, 
      {pru:'vanadio', linea:53, tipo:'CONTAMINANTES EXTERNOS, ppm (mg/kg)', nombre:''}, 
      {pru:'silicio', linea:54, tipo:'CONTAMINANTES EXTERNOS, ppm (mg/kg)', nombre:''}, 
      {pru:'sodio', linea:55, tipo:'CONTAMINANTES EXTERNOS, ppm (mg/kg)', nombre:''}, 
      {pru:'potasio', linea:56, tipo:'CONTAMINANTES EXTERNOS, ppm (mg/kg)', nombre:''}, 
      {pru:'boro', linea:57, tipo:'ADITIVOS DEL ACEITE, ppm (mg/kg)', nombre:''}, 
      {pru:'magnesio', linea:58, tipo:'ADITIVOS DEL ACEITE, ppm (mg/kg)', nombre:''}, 
      {pru:'calcio', linea:59, tipo:'ADITIVOS DEL ACEITE, ppm (mg/kg)', nombre:''}, 
      {pru:'fosforo', linea:60, tipo:'ADITIVOS DEL ACEITE, ppm (mg/kg)', nombre:''}, 
      {pru:'zinc', linea:61, tipo:'ADITIVOS DEL ACEITE, ppm (mg/kg)', nombre:''}, 
      {pru:'molibdeno', linea:62, tipo:'ADITIVOS DEL ACEITE, ppm (mg/kg)', nombre:''}, 
      {pru:'bario', linea:63, tipo:'ADITIVOS DEL ACEITE, ppm (mg/kg)', nombre:''}, 
      {pru:'manganeso', linea:64, tipo:'ADITIVOS DEL ACEITE, ppm (mg/kg)', nombre:''},
      {pru:'color', linea:25, tipo:'Pruebas especiales', nombre:''},         
      {pru:'rulerP', linea:26, tipo:'Pruebas especiales', nombre:''},         
      {pru:'rulerA', linea:27, tipo:'Pruebas especiales', nombre:''},         
      {pru:'rulerF', linea:28, tipo:'Pruebas especiales', nombre:''},         
      {pru:'rulerZ', linea:29, tipo:'Pruebas especiales', nombre:''},         
      {pru:'rpvot', linea:30, tipo:'Pruebas especiales', nombre:''},         
      {pru:'barniz', linea:31, tipo:'Pruebas especiales', nombre:''},  
      {pru:'demulsibilidad', linea:32, tipo:'Pruebas especiales', nombre:''},         
      {pru:'demulsibilidadA', linea:33, tipo:'Pruebas especiales', nombre:''},         
      {pru:'demulsibilidadAg', linea:34, tipo:'Pruebas especiales', nombre:''},         
      {pru:'demulsibilidadE', linea:35, tipo:'Pruebas especiales', nombre:''},         
      {pru:'demulsibilidadT', linea:36, tipo:'Pruebas especiales', nombre:''},  
      {pru:'liberacion', linea:37, tipo:'Pruebas especiales', nombre:''},         
      {pru:'inflamacion', linea:38, tipo:'Pruebas especiales', nombre:''},         
      {pru:'corrosion', linea:39, tipo:'Pruebas especiales', nombre:''},
      {pru:'espumas1_0', linea:40, tipo:'Pruebas especiales', nombre:''},         
      {pru:'espumas1_10', linea:41, tipo:'Pruebas especiales', nombre:''},         
      {pru:'espumas2_0', linea:42, tipo:'Pruebas especiales', nombre:''},         
      {pru:'espumas2_10', linea:43, tipo:'Pruebas especiales', nombre:''},         
      {pru:'espumas3_0', linea:44, tipo:'Pruebas especiales', nombre:''},         
      {pru:'espumas3_10', linea:45, tipo:'Pruebas especiales', nombre:''},         
      {pru:'ultracentrifuga', linea:46, tipo:'Pruebas especiales', nombre:''}, 
      {pru:'densidad', linea:47, tipo:'Pruebas especiales', nombre:''}, 
      {pru:'apariencia', linea:49, tipo:'Pruebas especiales', nombre:''},         
      {pru:'olor', linea:50, tipo:'Pruebas especiales', nombre:''}, 
      {pru:'fuego', linea:48, tipo:'Pruebas especiales', nombre:''},
      {pru:'pq', linea:51, tipo:'Pruebas especiales', nombre:''}, 
      {pru:'fischer', linea:52, tipo:'Pruebas especiales', nombre:''},         
      {pru:'tanpte', linea:53, tipo:'Pruebas especiales', nombre:''}, 
      {pru:'tbnpte', linea:54, tipo:'Pruebas especiales', nombre:''},
    ]
  }


  handleSubmit = async (ev, list1)=>{
    if(list1.length>0){
      document.body.style.cursor = 'wait'

      let list = await list1.filter(elemento => elemento.estadoInflab === 'FINALIZADO')
      let argsBuscar = {tipoqry: `[${this.state.argsQuery}]`}
      console.log(argsBuscar)
      let listInf=[]
      let {data} = await this.props.allInflabRtesDash2.refetch(argsBuscar)
      listInf = await data.allInflabRtes
  

      let xlsString = []
      let xlsString1 = []
      xlsString1 = ['Tipo', 'Informe', 'Fecha muestra', 'Empresa', 'Planta', 'Sección', 'Equipo', 'Componente', 'Mecanismo', 
      'Lubricante', 'Estado', 'Tipo de prueba', 'Prueba', 'Resultado', 'Valoración', 'Estado prueba', 'Consecutivo']
      xlsString.push(xlsString1)

      let iiii=0
      for (const registro of list) {
        let fechaMuestra='', campoAgno = '', campoMes = '', campoDia = ''
        if(registro.fechaMuestra && registro.fechaMuestra.substring(4, 5)==='-' && registro.fechaMuestra.substring(7, 8)==='-' 
        && registro.fechaMuestra.substring(8, 10)!=='00' && registro.fechaMuestra.substring(1, 2)!=='/' 
        && registro.fechaMuestra.substring(2, 3)!=='/'){
          campoAgno = registro.fechaMuestra.substring(0, 4)
          campoMes = registro.fechaMuestra.substring(5, 7)
          campoDia = registro.fechaMuestra.substring(8, 10)
          fechaMuestra=campoAgno + '-' + campoMes + '-' + campoDia
          for (const campo in registro) {
            let valoracion=''
            let resultado = 0
            let campoE=campo+"E"
            let indexLinea = this.state.lineaPru.findIndex( lineaFind => lineaFind.pru===campo)
            if (indexLinea!==-1){
              if(registro[campo]!==null && registro[campo]!==''){
                let tipoPrueba=this.state.lineaPru[indexLinea].tipo
                let consecutivo=this.state.lineaPru[indexLinea].linea
                let estadoPrueba = registro[campoE]?registro[campoE]:''
                if(campo==='apariencia' || campo==='codigoPar' || campo==='corrosion' || campo==='olor'){
                  valoracion=registro[campo]
                }else{
                  resultado=registro[campo]
                }
                xlsString1 = ['Pruebas', registro.mecInflab, fechaMuestra, registro.descrEmpresa, 
                registro.descrPlanta, registro.descrSeccion, registro.descrEquipo, registro.descrComponente, registro.descrMecanismo, 
                registro.descrLubricante, registro.estado, tipoPrueba, campo, resultado, valoracion, estadoPrueba, consecutivo]
                xlsString.push(xlsString1)
              }
            }           
          }
        }


        if(iiii===list.length-1){

          var wb = XLSX.utils.book_new();

          wb.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            Author: "Red Stapler",
            CreatedDate: new Date(2017,12,19)
          };

          wb.SheetNames.push("Laboratorio2");

          let ws_data = xlsString;

          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          wb.Sheets["Laboratorio2"] = ws;
          let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
          function s2ab(s) { 
            let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            let view = new Uint8Array(buf);  //create uint8array as viewer
            for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
            return buf;    
          }
          document.body.style.cursor = 'default'
          saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Laboratorio2.xlsx');
        }
        iiii+=1
      }




      list = listInf
      let xlsString2 = []
      let xlsString12 = []
      xlsString12 = ['Tipo', 'Informe', 'Estado envío de muestra', 'Fecha creación', 'Fecha muestra', 'Fecha envío a lab.', 'Fecha recibe lab.', 'Fecha envío a cliente', 'Estado informe', 
      'Días envío a lab.', 'Días envío al cliente', 'Empresa', 'Planta', 'Sección', 'Equipo', 'Componente', 'Mecanismo', 'Lubricante', 
      'Estado lubricante', 'Recorrido', 'Cambio filtro aceite', 'Cambio filtro aire']

      xlsString2.push(xlsString12)

      for (let iiii=0;iiii<list.length;iiii++){
        let fechaMuestra='', campoAgno = '', campoMes = '', campoDia = '', tipoPrueba = '', prueba = '', resultado = '', estadoPrueba = ''
        let diasEnt = 0, diasLog = 0, filtroAc = 0, filtroAire = 0, reco = 0
        let fecEnvio = '', fecRecibe = '', fecCliente = '', fecCreacion = ''

        if(list[iiii].fechaMuestra && list[iiii].fechaMuestra.substring(4, 5)==='-' && list[iiii].fechaMuestra.substring(7, 8)==='-' 
          && list[iiii].fechaMuestra.substring(8, 10)!=='00' && list[iiii].fechaMuestra.substring(1, 2)!=='/' 
          && list[iiii].fechaMuestra.substring(2, 3)!=='/'){
          // if(list[iiii].fechaMuestra){
            campoAgno = list[iiii].fechaMuestra.substring(0, 4)
            campoMes = list[iiii].fechaMuestra.substring(5, 7)
            campoDia = list[iiii].fechaMuestra.substring(8, 10)
            fechaMuestra=campoAgno + '-' + campoMes + '-' + campoDia
        }
          campoAgno = list[iiii].fechaCreate.substring(0, 4)
          campoMes = list[iiii].fechaCreate.substring(5, 7)
          campoDia = list[iiii].fechaCreate.substring(8, 10)
          fecCreacion=campoAgno + '-' + campoMes + '-' + campoDia

          if(list[iiii].fechaEnvioLab){
            let fecha1 = moment(list[iiii].fechaEnvioLab).format('YYYY-MM-DD')
            fecEnvio = fecha1
          }
          if(list[iiii].fechaRecibeLab){
            let fecha2 = moment(list[iiii].fechaRecibeLab).format('YYYY-MM-DD')
            fecRecibe = fecha2
          }
          if(list[iiii].fechaEnvioCliente){
            let fecha3 = moment(list[iiii].fechaEnvioCliente).format('YYYY-MM-DD')
            fecCliente = fecha3
          }
          if(list[iiii].recorrido && list[iiii].recorrido>0){
            reco = list[iiii].recorrido
          }
          if(list[iiii].cambioFiltroAc && (list[iiii].cambioFiltroAc==='Si' || list[iiii].cambioFiltroAc==='SI' || list[iiii].cambioFiltroAc==='si' || list[iiii].cambioFiltroAc==='S' || list[iiii].cambioFiltroAc==='s')){
            filtroAc = 1
          }
          if(list[iiii].cambioFiltroAire && (list[iiii].cambioFiltroAire==='Si' || list[iiii].cambioFiltroAire==='SI' || list[iiii].cambioFiltroAire==='si' || list[iiii].cambioFiltroAire==='S' || list[iiii].cambioFiltroAire==='s')){
            filtroAire = 1
          }
          if(list[iiii].fechaEnvioCliente && list[iiii].fechaRecibeLab){
            let fecha1 = new Date(list[iiii].fechaEnvioCliente)
            fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
            fecha1=moment(fecha1)
            let fecha2 = new Date(list[iiii].fechaRecibeLab)
            fecha2 = (fecha2.getFullYear()) + '-' + ((fecha2.getMonth()+1)<10?'0'+(fecha2.getMonth()+1):(fecha2.getMonth()+1)) + '-' + (fecha2.getUTCDate()<10?'0'+fecha2.getUTCDate():fecha2.getUTCDate())
            fecha2=moment(fecha2)
            let numDias= fecha1.diff(fecha2, 'days')
            diasEnt = numDias
            // console.log(diasEnt)
            if(diasEnt===NaN || diasEnt==="NaN"){
              console.log(diasEnt)
              diasEnt=0
            }
          }
          if(list[iiii].fechaMuestra && list[iiii].fechaRecibeLab){
            let fecha1 = new Date(list[iiii].fechaRecibeLab)
            fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
            fecha1=moment(fecha1)
            let fecha2=new Date(list[iiii].fechaMuestra)
            let numDias= fecha1.diff(fecha2, 'days')
            diasLog = numDias
            if(diasLog===NaN || diasLog==="NaN"){
              diasLog=0
            }
          }


          xlsString12 = ['Informes', list[iiii].mecInflab, list[iiii].estadoEnvio?list[iiii].estadoEnvio:'', fecCreacion, fechaMuestra, 
          fecEnvio, fecRecibe, fecCliente, list[iiii].estadoInflab, diasLog, diasEnt,
          list[iiii].descrEmpresa, list[iiii].descrPlanta, list[iiii].descrSeccion, list[iiii].descrEquipo, 
          list[iiii].descrComponente, list[iiii].descrMecanismo, list[iiii].descrLubricante, list[iiii].estado, reco, filtroAc, filtroAire]
          

          xlsString2.push(xlsString12)
        // }
        if(iiii===list.length-1){

          var wb = XLSX.utils.book_new();

          wb.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            Author: "Red Stapler",
            CreatedDate: new Date(2017,12,19)
          };

          wb.SheetNames.push("Laboratorio1");

          let ws_data = xlsString2;

          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          wb.Sheets["Laboratorio1"] = ws;
          let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
          function s2ab(s) { 
            let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            let view = new Uint8Array(buf);  //create uint8array as viewer
            for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
            return buf;    
          }
          document.body.style.cursor = 'default'
          saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Laboratorio1.xlsx');
//FIN Exportar a XLS
        }
      }


      

      // await this.props.allInflabRtes.refetch()
      this.setState({open: false, confirmaAct: false})
    }
    

  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  render(){
    const {permiteUpdate, confirmaAct, open} = this.state;
    let mensaje = "Descargar matríz en Excel"
    let imgIcon = "images/documento_32.png"
    let list = []
    console.log(this.props.allInflabRtesDash1.allInflabRtes)
    if(this.props.allInflabRtesDash1.allInflabRtes){list = this.props.allInflabRtesDash1.allInflabRtes}
    // let list2 = []
    // if(this.props.allInflabRtesDash2.allInflabRtes){list2 = this.props.allInflabRtesDash2.allInflabRtes}

    console.log(list)
    // console.log(list2.length)

    return (
      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list):()=>{}}>
          <div className="ui two column stackable grid">
            <div className="row container">
              {list.length>0 &&
                <div className="column" style={{width: '30%', paddingTop: '0.1em'}}>
                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
              }
            </div>
          </div>
        </Form>
      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allInflabRtes, {name:'allInflabRtesDash1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {fechaCreate: { $gte: new Date('2024-06-01')}, 'estadoInflab': {$in: ['FINALIZADO', 'GENERADO']}}}]`
  }}}}),
  graphql(queries.query.allInflabRtes, {name:'allInflabRtesDash2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': 'FINALIZADO', 'numeroInflab': 0}}, {$sort: {_id: -1}}]`}}}}),
  
//   graphql(queries.query.allInflabRtes, {name:'allInflabRtesDash2',
//     options: (props) => {return {variables: {tipoqry: `[{$match: {'mecInflab': {$gt: 5000}}}, 
//     {$project: {fechaMuestra: 1, estadoInflab: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, 
//     descrEquipo: 1, descrComponente: 1, descrMecanismo: 1, fechaEnvioLab: 1, fechaRecibeLab: 1, fechaEnvioCliente: 1, 
//     mecInflab: 1, aceiteRep: 1, recorrido: 1, cambioFiltroAc: 1, cambioFiltroAire: 1}}
// ]`}}}}), 
)(LabDashboard2)
